import { M } from '../mensajes/es-PE';
import { useAvisos } from './avisos';
import { Icono } from './Icono';

export function Avisos() {
  const avisos = useAvisos((s) => s.avisos);
  const cerrar = useAvisos((s) => s.cerrar);
  return (
    <div className="avisos" role="status" aria-live="polite">
      {avisos.map((a) => (
        <div key={a.id} className={`aviso ${a.tipo}`} data-testid="aviso">
          <p>{a.texto}</p>
          <button
            type="button"
            className="boton fantasma icono chico"
            onClick={() => cerrar(a.id)}
            aria-label={M.app.cerrar}
          >
            <Icono nombre="cerrar" tamano={16} />
          </button>
        </div>
      ))}
    </div>
  );
}
